// ----------------------------------------------------------------------
// <copyright file="Izenda.ExploreCtaConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import localizer from 'share/localization/Izenda.Localizer';

/**
 * @constant EXPLORE_CTAS_KEYS
 * @description Keys for card ctas specific to the explore home page
 */
const EXPLORE_CTA_KEYS = [
    'DATA_SOURCE',
    'DASHBOARD',
    'REPORT'
];

/**
 * @constant CTA_URLS
 * @description urls for each mapped cta key
 */
const CTA_URLS = {
    DATA_SOURCE: '/settings',
    DASHBOARD: '/dashboard/new',
    REPORT: '/reportdesigner'
};

/**
 * @constant CTA_IMAGE_MODIFIERS
 * @description scss image class modifier names for each cta key
 */
const CTA_IMAGE_MODIFIERS = {
    DATA_SOURCE: 'data-source',
    DASHBOARD: 'new-dashboard',
    REPORT: 'new-report'
};

export default {
    /**
     * @constant EXPLORE_CTAS
     * @description an array of card cta configurations for the explore home page
     */
    get EXPLORE_CTAS() {
        return EXPLORE_CTA_KEYS.map((cta) => ({
            description: localizer.getText(`EXPLORE_CTAS.${cta}`).DESCRIPTION,
            imageModifier: CTA_IMAGE_MODIFIERS[cta],
            label: localizer.getText(`EXPLORE_CTAS.${cta}`).LABEL,
            path: CTA_URLS[cta]
        }));
    }
}



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.ExploreCtaConstants.js